import CustomFields from './view';

export default CustomFields;